import { render } from "./AddressSelectionCard.vue?vue&type=template&id=54356eee&scoped=true"
import script from "./AddressSelectionCard.vue?vue&type=script&lang=js"
export * from "./AddressSelectionCard.vue?vue&type=script&lang=js"

import "./AddressSelectionCard.vue?vue&type=style&index=0&id=54356eee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54356eee"]])

export default __exports__